import { requiredInputRule } from "@erp/shared/utils/form/rules";
export const classificationInputs = [
    {
        label: "자재 분류",
        key: "classification",
        column_name: "classification",
        col: "12",
        sm: "12",
        lg: "12",
        value: "",
        rules: [requiredInputRule],
    },
];
export const manufacturerInputs = [
    {
        label: "제조사",
        key: "manufacturer",
        column_name: "manufacturer",
        col: "12",
        sm: "12",
        lg: "12",
        value: "",
        rules: [requiredInputRule],
    },
];
export const spotInputs = [
    {
        label: "위치",
        key: "spot",
        column_name: "spot",
        col: "12",
        sm: "12",
        lg: "12",
        value: "",
        rules: [requiredInputRule],
    },
];
export const classificationHeaders = [
    { text: "자재 분류", align: "start", value: "classification" },
    { text: "편집", align: "center", value: "actions" },
];
export const manufacturerHeaders = [
    { text: "제조사", align: "start", value: "manufacturer" },
    { text: "편집", align: "center", value: "actions" },
];
export const spotHeaders = [
    { text: "위치", align: "start", value: "spot" },
    { text: "편집", align: "center", value: "actions" },
];
